"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconLightiningFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconLightiningFilled = function SvgIconLightiningFilled(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.843.539A.523.523 0 015.311.25h3.136a.523.523 0 01.468.756l-.589 1.177-.776 1.552h2.64a.523.523 0 01.418.836l-5.228 6.97a.523.523 0 01-.929-.423l.91-4.247H2.523a.523.523 0 01-.468-.756L4.843.539zm.332 6.482H2.523a.673.673 0 01-.602-.973L4.709.472A.673.673 0 015.31.1h3.136a.673.673 0 01.602.974M5.175 7.02l-.87 4.065a.673.673 0 001.195.545l5.227-6.97a.673.673 0 00-.538-1.076H7.793l1.256-2.511",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.31.25a.523.523 0 00-.467.289L2.055 6.115a.523.523 0 00.468.756h2.75l3.053-4.688.588-1.177A.523.523 0 008.447.25H5.311z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.657 4.024a.523.523 0 00-.468-.29H7.55l.776-1.551L5.273 6.87h.088l-.91 4.247a.523.523 0 00.93.423l5.227-6.97a.523.523 0 00.049-.547z",
    fill: "currentColor"
  }));
};

exports.SvgIconLightiningFilled = SvgIconLightiningFilled;